import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Avatar from 'LegacyWeployDesignLanguage/Avatar';

const StyledAvatarContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: ${props => props.theme.spacing[1]};

  & > :not(:last-child) {
    margin-right: ${props => props.theme.spacing[1]};
  }
`;

const renderAvatars = (avatars, maxAvatars) => {
  if (maxAvatars === 0) { return null; }

  if (avatars.length > maxAvatars) {
    const numberOfWeployeeAvatarsToDisplay = maxAvatars - 1;

    return (
      <>
        { avatars.slice(0, numberOfWeployeeAvatarsToDisplay).map(avatar => (
          <Avatar
            key={avatar.url}
            src={avatar.url}
            alt="Weployee's avatar"
            size={Avatar.EXTRA_EXTRA_SMALL}
          />
        ))}
        <Avatar
          size={Avatar.EXTRA_EXTRA_SMALL}
          text={`+${avatars.length - numberOfWeployeeAvatarsToDisplay}`}
          backgroundColor={Avatar.DARKER_GREEN}
        />
      </>
    );
  }

  return avatars.map(avatar => (
    <Avatar
      key={avatar.url}
      src={avatar.url}
      alt="Weployee's avatar"
      size={Avatar.EXTRA_EXTRA_SMALL}
    />
  ));
};


const Avatars = ({ avatars, maxAvatars }) => (
  <StyledAvatarContainer>
    {renderAvatars(avatars, maxAvatars)}
  </StyledAvatarContainer>
);

Avatars.propTypes = {
  maxAvatars: PropTypes.number.isRequired,
  avatars: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
  })).isRequired,
};


export default Avatars;
